import React, { useReducer, useEffect } from 'react';
import { reducer } from './reducer';

const DEFAULT_TRANSITION = 'transform 0.25s ease 0s';

const initialState = {
  current: 0,
  offset: 0,
  transition: DEFAULT_TRANSITION,
  count: 0,
};

const Carousel = ({ width, children }) => {
  const childrenArray = React.Children.toArray(children);
  childrenArray.push(React.cloneElement(childrenArray[0]));

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch({
        type: 'tick',
        payload: { width, count: childrenArray.length },
      });
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (state.count > 0 && state.current === state.count - 1)
      setTimeout(() => {
        dispatch({ type: 'reset' });
      }, 300);
  }, [state.count, state.current]);

  return (
    <section style={{ display: 'flex', overflow: 'hidden' }}>
      <>
        {childrenArray.map((child, index) => (
          <div
            key={`Carousel_a${index}`}
            style={{
              flex: `0 0 ${width}px`,
              transition: state.transition,
              transform: `translateX(${state.offset}px)`,
            }}
          >
            {child}
          </div>
        ))}
      </>
    </section>
  );
};

export default Carousel;
